export interface ISCUser {
  Role: Roles;
  Profile: Profiles;
  TechnicalRole?: any;
  StatusText?: string;
}

export const RoleEnum = {
  MANAGER: "MANAGER",
  MANAGER_SALES_LIST: "MANAGER_SALES_LIST",
  MANAGER_SALES_TEAM: "MANAGER_TEAM_DESK_SALES_LIST",
  MANAGER_SALES_TEAM_BU: "MANAGER_TEAM_DESK_BU_LIST",
  SALES: "SALES",
};

export const ProfileEnum = {
  CASH_EQUITY_SALES: "CASH_EQUITY_SALES",
  CASH_EQUITY_TRADER: "CASH_EQUITY_TRADER",
  EMPTY: "",
  TICKERS: "TICKERS",
};

export type Roles =
  | "MANAGER"
  | "SALES"
  | "MANAGER_SALES_LIST"
  | "MANAGER_TEAM_DESK_BU_LIST";
export type Profiles =
  | "TICKERS"
  | "CASH_EQUITY_TRADER"
  | "CASH_EQUITY_SALES"
  | "";
